import React from "react";
import { cn } from "../../../lib/utils";

interface DocsSlackButtonProps {
  className?: string;
}

export function DocsSlackButton({ className }: DocsSlackButtonProps) {
  return (
    <a
      href="https://slack.com/oauth/v2/authorize?client_id=8228472016453.9830655217430&scope=channels:history,channels:read,groups:history,groups:read,team:read,channels:join&user_scope=users:read,usergroups:read"
      className={cn(
        "inline-block my-6 hover:opacity-80 transition-opacity",
        className,
      )}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        alt="Add to Slack"
        height="40"
        width="139"
        src="https://platform.slack-edge.com/img/add_to_slack.png"
        srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
      />
    </a>
  );
}
